module.exports = __webpack_public_path__ + "img/hero.b68c1ccd.png";